import React, { useState } from 'react';
import UserActionConfirmModal from 'pages/userManagementV3/localComponent/userActionConfirmModal';
import NoDataIcon from '../../../Assets/ill-no-data.svg';
import { fluid, fluidVh } from 'components/UserDashboardV2/utils/responsive';

const DocumentsTab = ({
    leftColumnHeight,
    documents,
    documentsLoading,
    deletingDocId,
    onAddClick,
    uploadingDocuments,
    onReplaceClick,
    onDeleteClick,
}) => {
    // Doc id awaiting delete confirmation.
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const isDeleting = confirmDeleteId != null && deletingDocId === confirmDeleteId;

    return (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", height: leftColumnHeight, backgroundColor: "#FFFFFF", borderRadius: fluid(24), boxSizing: "border-box", overflow: "hidden" }}>
            {/* Header of Card */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: `${fluid(36)} ${fluid(24)} ${fluid(24)}`, boxSizing: "border-box", flexShrink: 0 }}>
                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(24), fontWeight: 500, color: "#191919" }}>
                    Document library ({documents.length})
                </span>
                <button
                    type="button"
                    onClick={() => !uploadingDocuments && onAddClick()}
                    disabled={uploadingDocuments}
                    style={{
                        width: fluid(203),
                        height: fluid(45),
                        backgroundColor: "#594099",
                        border: "2px solid #594099",
                        borderRadius: fluid(12),
                        color: "#FFFFFF",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: fluid(16),
                        fontWeight: 700,
                        cursor: uploadingDocuments ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {uploadingDocuments ? "UPLOADING..." : "ADD DOCUMENT"}
                </button>
            </div>

            {/* Scrollable list of document rows */}
            <div style={{ flex: 1, overflowY: "auto", padding: `0 ${fluid(24)} ${fluid(24)}`, display: "flex", flexDirection: "column", gap: fluid(12) }} className="staff-profile-info-scroll">
                {documentsLoading ? null : documents.length === 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: fluid(40) }}>
                        <img src={NoDataIcon} alt="" style={{ width: fluid(200), height: fluid(200) }} />
                        <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(24), fontWeight: 500, color: "#191919", marginTop: fluid(16) }}>
                            No documents uploaded yet
                        </span>
                    </div>
                ) : documents.map((doc) => (
                    <div key={doc.id} style={{ width: "100%", height: fluidVh(96), backgroundColor: "#F9F9F9", borderRadius: fluid(20), border: "1px solid #EFEFEF", padding: fluid(16), boxSizing: "border-box", display: "flex", alignItems: "center" }}>
                        {/* Thumbnail Icon */}
                        <div style={{ width: fluid(64), height: fluid(64), borderRadius: fluid(12), backgroundColor: doc.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <img src={doc.icon} alt="" style={{ width: fluid(doc.iconFillsTile ? 64 : 40), height: fluid(doc.iconFillsTile ? 64 : 40) }} />
                        </div>

                        {/* Document Info */}
                        <div style={{ display: "flex", flexDirection: "column", gap: fluid(6), marginLeft: fluid(20) }}>
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(20), fontWeight: 500, color: "#191919" }}>
                                {doc.name}
                            </span>
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(14), color: "#666666", fontWeight: 400 }}>
                                {doc.meta}
                            </span>
                        </div>

                        {/* Action Links */}
                        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: fluid(58), paddingRight: fluid(16) }}>
                            <span
                                onClick={() => deletingDocId == null && onReplaceClick(doc.id)}
                                style={{
                                    fontFamily: "Roboto, sans-serif", fontSize: fluid(16), fontWeight: 700, color: "#FF9500",
                                    cursor: deletingDocId != null ? "not-allowed" : "pointer",
                                }}
                            >
                                REPLACE
                            </span>
                            <span
                                onClick={() => deletingDocId == null && setConfirmDeleteId(doc.id)}
                                style={{
                                    fontFamily: "Roboto, sans-serif", fontSize: fluid(16), fontWeight: 700, color: "#FF414D",
                                    cursor: deletingDocId != null ? "not-allowed" : "pointer",
                                }}
                            >
                                DELETE
                            </span>
                            <span
                                onClick={() => doc.url && window.open(doc.url, '_blank', 'noopener,noreferrer')}
                                style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(16), fontWeight: 700, color: doc.url ? "#594099" : "#AEAEAE", cursor: doc.url ? "pointer" : "not-allowed" }}
                            >
                                VIEW
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            <UserActionConfirmModal
                open={confirmDeleteId != null}
                action="documentDelete"
                loading={isDeleting}
                onCancel={() => setConfirmDeleteId(null)}
                onConfirm={() => onDeleteClick(confirmDeleteId, () => setConfirmDeleteId(null))}
            />
        </div>
    );
};

export default DocumentsTab;
